﻿import { span } from 'common/barrels/dom';
import { bind, ReadOnlyBinding } from 'common/dom/binding';
import { Observable } from 'common/barrels/rx';

export function label(value: ReadOnlyBinding<string>, setTitle = false) {
    const $element = span('studio-label');

    const setText = x => $element.text(x);

    const subscriptions = bind<string>(value,
        setTitle ? x => { setText(x); $element.attr('title', x); } : setText,
        () => Observable.never<string>()
    );

    return $element.owns(subscriptions);
}